export default {
  OK: 0,
  UNKNOWN_ERROR: 1,
  NOT_AUTHENTICATED: 100,
};



// WEBPACK FOOTER //
// ./src/model/StatusCodes.js